export const SET_BANNERS_LIST = 'banners/SET_BANNERS_LIST'
export const SET_MANAGE_BANNER = 'banners/SET_MANAGE_BANNER'
export const SAVE_BANNER = 'banners/SAVE_BANNER'
